import { Flame } from "lucide-react"
import { InfoTip } from "@/components/custom/fire/info-tip"
import type { FireStreak } from "@/types/fire"

interface FireStreakBadgeProps {
	streak: FireStreak
}

export function FireStreakBadge({ streak }: FireStreakBadgeProps) {
	if (streak.consecutive_months === 0 && streak.longest_streak === 0) return null

	return (
		<div className="flex items-center gap-3 p-3 rounded-lg bg-sky-50 dark:bg-sky-900/20 border border-sky-200/50 dark:border-sky-700/30">
			<Flame className="h-5 w-5 text-sky-500 shrink-0" />
			<div>
				<p className="text-sm font-medium flex items-center gap-1">
					{streak.consecutive_months} month{streak.consecutive_months !== 1 ? "s" : ""} of consecutive income
					growth
					<InfoTip content="Consecutive months where total dividend income increased compared to the same month one year earlier." />
				</p>
				{streak.longest_streak > streak.consecutive_months && (
					<p className="text-xs text-muted-foreground">Longest streak: {streak.longest_streak} months</p>
				)}
			</div>
		</div>
	)
}
